import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CorrelationService } from './correlation.service';

@Injectable()
export class CorrelationInterceptor implements HttpInterceptor {
  constructor(private correlationService: CorrelationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get or create correlation ID for this request
    const correlationId = this.correlationService.getOrCreateCorrelationId();
    
    // Add correlation ID as query parameter to match backend expectation
    let modifiedReq = req;
    
    // Check if URL already has query parameters
    const separator = req.url.includes('?') ? '&' : '?';
    const urlWithCorrelation = `${req.url}${separator}correlationGuid=${correlationId}`;
    
    // Clone the request with the correlation ID
    modifiedReq = req.clone({
      url: urlWithCorrelation,
      setHeaders: {
        // Also add as header for additional tracking
        'X-Correlation-ID': correlationId
      }
    });

    // Log the outgoing request with correlation
    this.correlationService.logWithCorrelation(
      `HTTP ${req.method} request to ${req.url}`,
      {
        method: req.method,
        url: req.url,
        urlWithCorrelation: urlWithCorrelation,
        headers: req.headers.keys(),
        body: req.body
      }
    );

    // Handle the request and log the response
    return next.handle(modifiedReq).pipe(
      tap({
        next: (event) => {
          if (event.type === 4) { // HttpEventType.Response
            this.correlationService.logWithCorrelation(
              `HTTP ${req.method} response from ${req.url}`,
              {
                status: (event as any).status,
                statusText: (event as any).statusText,
                responseTime: new Date().toISOString()
              }
            );
          }
        },
        error: (error) => {
          this.correlationService.logWithCorrelation(
            `HTTP ${req.method} error from ${req.url}`,
            {
              status: error.status,
              statusText: error.statusText,
              message: error.message,
              error: error
            }
          );
        }
      })
    );
  }
}